import React from "react";
import { useNavigate } from "react-router-dom";

export default function BlogTypeSelection() {
  const navigate = useNavigate();

  const handleSelect = (type) => {
    navigate(`/create-blog/${type}`);
  };

  const blogTypes = [
    {
      type: "A",
      title: "Style A - Comprehensive Guide",
      description: "Ideal for detailed reviews with sections (like 32-degrees format). Full hero image, intro, multiple body sections, pro tips, and final verdict.",
      skeleton: (
        <div className="flex flex-col space-y-2 border border-gray-300 p-2 rounded-md h-full bg-white">
          <div className="w-full h-12 bg-gray-200 rounded"></div>
          <div className="w-full h-4 bg-gray-200 rounded"></div>
          <div className="w-full h-8 bg-gray-200 rounded"></div>
          <div className="w-full h-8 bg-gray-200 rounded"></div>
        </div>
      )
    },
    {
      type: "B",
      title: "Style B - Hero & Content",
      description: "Simple and clean. Top full image followed by the content body.",
      skeleton: (
        <div className="flex flex-col space-y-2 border border-gray-300 p-2 rounded-md h-full bg-white">
          <div className="w-full h-16 bg-gray-200 rounded"></div>
          <div className="w-full h-4 bg-gray-200 rounded"></div>
          <div className="w-full h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        </div>
      )
    },
    {
      type: "C",
      title: "Style C - Premium Wrapped Image",
      description: "Elegant modern style. Content tightly wraps around a floated image, with a prominent drop-cap and a minimalist quote box.",
      skeleton: (
        <div className="flex flex-col space-y-2 border border-gray-300 p-2 rounded-md h-full bg-white">
          <div className="w-full flex space-x-2">
            <div className="w-1/3 h-12 bg-gray-200 rounded"></div>
            <div className="w-2/3 h-4 bg-gray-200 rounded"></div>
          </div>
          <div className="w-full h-8 bg-gray-200 rounded"></div>
          <div className="w-full h-4 bg-gray-200 rounded"></div>
        </div>
      )
    },
    {
      type: "D",
      title: "Style D - Split View",
      description: "Left side features a prominent image, while the right side introduces the main content.",
      skeleton: (
        <div className="flex space-x-2 border border-gray-300 p-2 rounded-md h-full bg-white">
          <div className="w-1/2 h-full bg-gray-200 rounded"></div>
          <div className="w-1/2 flex flex-col space-y-2">
            <div className="w-full h-4 bg-gray-200 rounded"></div>
            <div className="w-full h-4 bg-gray-200 rounded"></div>
          </div>
        </div>
      )
    }
  ];

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Select Blog Layout Style</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {blogTypes.map((b) => (
          <div 
            key={b.type} 
            className="border border-gray-200 bg-gray-50 rounded-lg p-4 cursor-pointer hover:shadow-lg transition-shadow duration-200 flex flex-col"
            onClick={() => handleSelect(b.type)}
          >
            <h2 className="text-xl font-semibold mb-2">{b.title}</h2>
            <p className="text-gray-600 mb-4 text-sm flex-grow">{b.description}</p>
            <div className="h-40 w-full mb-4">
              {b.skeleton}
            </div>
            <button className="bg-red-600 text-white w-full py-2 rounded font-semibold hover:bg-red-700">
              Use Style {b.type}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
